export default __webpack_public_path__ + "static/media/news-thumb4.5e150787.png";